import { render } from "./BizTooltip.vue?vue&type=template&id=705ad43e&ts=true"
import script from "./BizTooltip.vue?vue&type=script&lang=ts"
export * from "./BizTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__